import { useEffect } from "react";

export const useAppendLandingId = (landingId, deps = []) => {
  useEffect(() => {
    if (!landingId) return;

    const links = document.querySelectorAll("a[href]");
    links.forEach((link) => {
      if (link.href.startsWith("mailto:")) return;

      const url = new URL(link.href, window.location.origin);

      if (!url.searchParams.has("landing_id")) {
        url.searchParams.set("landing_id", landingId);
        link.href = url.toString();
      }
    });
  }, [landingId, ...deps]);
};
